/** Normalize question payloads from learning / home APIs for flashcards. */
export function normalizeLearningQuestion(raw) {
  if (raw == null || typeof raw !== 'object') return null;

  const id = raw.id ?? raw.questionId;
  if (id == null) return null;

  return {
    id: Number(id),
    question: String(raw.question ?? raw.ques ?? '').trim(),
    answer: String(raw.answer ?? raw.ans ?? '').trim(),
    extraInfo: raw.extraInfo != null ? String(raw.extraInfo) : '',
    topic: String(raw.topic ?? 'General').trim(),
    category: String(raw.category ?? '').trim(),
    subCategory1: String(raw.subCategory1 ?? raw.subCat1 ?? '').trim(),
    subCategory2: String(raw.subCategory2 ?? raw.subCat2 ?? '').trim(),
    mediumUrl: raw.mediumUrl ?? raw.medium_url ?? null,
  };
}

export function normalizeLearningDeck(list) {
  if (!Array.isArray(list)) return [];
  return list.map(normalizeLearningQuestion).filter(Boolean);
}
